import { useSettings } from '../App/SettingsContext';
import { useState } from 'react';

const SingleProductQuoteButton = ({ productId }) => {
  const [addingToQuote, setAddingToQuote] = useState(false);
  const {
    settings,
    loading,
    addToQuote,
    isProductInQuote,
  } = useSettings();

  const added = isProductInQuote(productId);

  const handleAddToQuote = async () => {
    if (added) return;
    await addToQuote(productId);
  };

  return (
    <div className="mctq_quote_btn">
      <button
        className="button product_type_simple"
        disabled={added || addingToQuote}
        onClick={async () => {
          setAddingToQuote(true);
          await handleAddToQuote();
          setAddingToQuote(false);
        }}
        style={{
          backgroundColor: added ? '#e5e7eb' : settings.quote_btn_bg_color,
          color: added ? '#6b7280' : settings.quote_btn_text_color,
          fontSize: settings.quote_btn_font_size + 'px',
          cursor: added ? 'not-allowed' : 'pointer',
          opacity: addingToQuote ? 0.7 : 1,
          padding: '10px 22px',
          textDecoration: 'none',
          display: 'inline-block',
          border: '0',
          borderRadius: '0',
          lineHeight: '1.5',
          fontFamily: 'inherit'
        }}
      >
        {added ? 'Added to Quote' : settings.quote_button_customize}
      </button>

      {addingToQuote && (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div
            className="spinner"
            style={{ width: '20px', height: '20px', borderWidth: '2px' }}
          />
        </div>
      )}
    </div>
  );
};

export default SingleProductQuoteButton;
